import { UserId } from '@cibo/core'
import { createContext, useContext } from 'react'
import { LimitDefinition } from './utils/programLimitUtils'

interface ProgramLimitContextProps {
  isReady: boolean
  display: boolean
  limits?: [LimitDefinition, LimitDefinition] | [LimitDefinition]
  programId: string
  workflowId: string
  userId?: UserId
  prevent: boolean
}

export const ProgramLimitContext = createContext<ProgramLimitContextProps>({
  isReady: false,
  display: false,
  programId: '',
  workflowId: '',
  prevent: false,
})
ProgramLimitContext.displayName = 'ProgramLimitContext'

export const useProgramLimit = () => useContext(ProgramLimitContext)

export const SelectedFieldsProgramLimitContext = createContext<ProgramLimitContextProps>({
  isReady: false,
  display: false,
  programId: '',
  workflowId: '',
  prevent: false,
})
SelectedFieldsProgramLimitContext.displayName = 'SelectedFieldsProgramLimitContext'

export const useSelectedFieldsProgramLimit = () => useContext(SelectedFieldsProgramLimitContext)
